<template>
  <div class="policy_detail">
    <!--  包屑 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/policy_info'}">政策列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{params.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 项目申报 -->
    <project v-if="active==='PolicyTypeProject' || active===''" :detail="params" :relate="relate"/>
    <!-- 政策法规 -->
    <regulations v-if="active==='PolicyTypeRegulations'" :detail="params" :relate="relate" />
    <!-- 公示名录 -->
    <publicity v-if="active==='PolicyTypePublicityDirectory'" :detail="params" :relate="relate" />
    <!-- 招标公告 -->
    <notice v-if="active==='PolicyTypeZhaobiaoNotice'" :detail="params" :relate="relate" />
    <!-- 政府工作 -->
    <government v-if="active==='PolicyTypeGovernmentWork'" :detail="params" :relate="relate" />
  </div>
</template>

<script>
  import project from './components/project'
  import regulations from "./components/regulations"
  import publicity from "./components/publicity.vue"
  import notice from "./components/notice.vue"
  import government from "./components/government.vue"
  export default {
    components: {
      project,
      regulations,
      publicity,
      notice,
      government
    },
    data(){
      return{
        active: this.$route.query.type||'',
        login: false,
        params: {name:''},
        relate:[]
      }
    },
    created() {
      if(sessionStorage.getItem('loginKey')){
        this.login = true;
      }
      this.getData();
    },
    methods:{
      toLogin(url){
        this.$router.push({
          path:'/login?redirect='+this.$route.fullPath,
        })
      },
      getData(){
        let params = {
          id: this.$route.query.id,
        }
        let login = sessionStorage.getItem('loginKey') !== null && sessionStorage.getItem('loginKey') !== '';
        this.api.getESPolicys(params, login).then(res=>{
          if(res.error['err_code']!==0)return;
          let obj = res.obj.list[0]||{};
          if(obj.end_date){
            let date = this.common.formatDate(new Date(), 'yyyy-MM-dd')
            obj.end_day = this.getDaysBetween(obj.end_date,date)
          }
          obj.release_date = obj.release_date?this.common.formatDate(new Date(obj.release_date),'yyyy-MM-dd'):'';
          let codes = obj.types_code?obj.types_code.split(','):[];
          let types = ['PolicyTypeProject','PolicyTypeRegulations','PolicyTypePublicityDirectory','PolicyTypeZhaobiaoNotice','PolicyTypeGovernmentWork'];
          let type = 'PolicyTypeProject';
          for(let i = 0 ; i < types.length ; ++i){
            if(codes.includes(types[i])){
              type = types[i];
              break;
            }
          }
          this.active = this.active || type;
          this.params = obj;
          this.getRelates();
        })
      },

      //查询相关政策
      getRelates(){
        let login = sessionStorage.getItem('loginKey') || false;
        if(!login) return;
        this.api.getRelates({
          policy: this.params.id,
          pageSize: 999
        }, true).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.relate = res.obj.list;
        })
      },
      //计算两个日期之间的天数
      getDaysBetween(startTime,endTime){
        const stTime=Date.parse(new Date(startTime));
        const etTime=Date.parse(new Date(endTime));
        if(stTime===etTime){
          return 1+'天';
        }
        if(stTime<etTime){
          return '已截止'
        }
        const usedTime = stTime - etTime;
        const days=Math.floor(usedTime/(24*3600*1000));
        return days+'天';
      },
    }
  }
</script>

<style lang="scss">
  @import "../style";
  .policy_detail{
    background-color: #F3F6F8;
    overflow: hidden;
    .my_header{
      background-color: #ffffff;
    }
    .breadcrumb{
      width: 1200px;
      margin: 0 auto;
      padding: 16px 0;
      .el-breadcrumb>.el-breadcrumb__item:last-child>.el-breadcrumb__inner{
        font-weight: 400;
        color: #4c84ff;
      }
      .el-breadcrumb>.el-breadcrumb__item>.is-link{
        font-weight: 400;
      }
      .el-breadcrumb>.el-breadcrumb__item:last-child{
        width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    /*.detail_content{*/
    /*  width: 1200px;*/
    /*  margin: 0 auto;*/
    /*  margin-bottom: 65px;*/
    /*  padding: 40px 32px;*/
    /*  box-sizing: border-box;*/
    /*  overflow: hidden;*/
    /*  background-color: #fff;*/
    /*  border-radius: 4px;*/
    /*  h3{*/
    /*    font-size: 24px;*/
    /*    line-height: 34px;*/
    /*    color: #4B5062;*/
    /*    font-weight: bold;*/
    /*    margin-bottom: 24px;*/
    /*  }*/
    /*  dl{*/
    /*    background-color: #F9F9FC;*/
    /*    margin-top: 32px;*/
    /*    padding: 24px 30px;*/
    /*    display: flex;*/
    /*    flex-wrap: wrap;*/
    /*    border-radius: 4px;*/
    /*    dd{*/
    /*      min-width: 180px;*/
    /*      max-width: 250px;*/
    /*      font-size: 14px;*/
    /*      color: #9FA4B1;*/
    /*      line-height: 20px;*/
    /*      margin-right: 59px;*/
    /*    }*/
    /*    dd.primary{*/
    /*      color: #4c84ff;*/
    /*    }*/
    /*    dd:nth-last-child(-n+2){*/
    /*      margin-top: 14px;*/
    /*    }*/
    /*    dd:nth-child(n+1):nth-child(-n+4){*/
    /*      margin-top: 0;*/
    /*    }*/
    /*  }*/
    /*  .original{*/
    /*    display: inline-block;*/
    /*    margin-top: 40px;*/
    /*    color: #0000EE;*/
    /*    text-decoration: underline;*/
    /*    font-size: 14px;*/
    /*  }*/
    /*  .link{*/
    /*    display: inline-block;*/
    /*    color: #2B6AE1;*/
    /*    font-size: 14px;*/
    /*    line-height: 20px;*/
    /*  }*/
    /*  .declare{*/
    /*    display: inline-block;*/
    /*    font-size: 14px;*/
    /*    line-height: 20px;*/
    /*    padding: 8px 16px;*/
    /*    color: #ffffff;*/
    /*    background-color: #4c84ff;*/
    /*    border-radius: 2px;*/
    /*  }*/
    /*  ul{*/
    /*    margin-top: 24px;*/
    /*    padding-top: 24px;*/
    /*    border-top: 1px solid #eeeeee;*/
    /*  }*/
    /*  ul li{*/
    /*    margin-bottom: 24px;*/
    /*    &:last-child{*/
    /*      margin-bottom: 0;*/
    /*    }*/
    /*    h4{*/
    /*      font-size: 14px;*/
    /*      line-height: 20px;*/
    /*      color: #666666;*/
    /*    }*/
    /*    .text{*/
    /*      margin-top: 8px;*/
    /*    }*/
    /*  }*/
    /*}*/
    .mt8{
      margin-top: 8px;
    }
    .mt16{
      margin-top: 16px;
    }
  }
</style>
